export default "__VITE_ASSET__DRXlWqI4__"